<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/dashboard/customers' }"
        >客户管理</el-breadcrumb-item
      >
      <el-breadcrumb-item>客户详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <h6 class="content-header">客户详情</h6> -->
    <div class="mt-20">
      <el-button
        type="primary"
        icon="el-icon-notebook-2"
        size="small"
        @click="startCreateFollowup"
        >新拜访</el-button
      >
      <el-button
        plain
        type="primary"
        icon="el-icon-top-right"
        size="small"
        @click="startTransfer()"
        >转移</el-button
      >
    </div>
    <div class="panel customer-info-panel mt-20" v-if="customer">
      <div class="header customer-info-title flex-row-between">
        <span style="flex: 1">{{ customer.name }}</span>
        <status-tag
          style="width: 40px; font-size: 12px"
          :type="customer.status == 1 ? 'success' : 'danger'"
          :name="CustomerStatusMap[customer.status]"
        ></status-tag>
      </div>
      <div class="customer-detail">
        <dl>
          <dt>地址</dt>
          <dd>
            {{ codeToText[customer.province] }}{{ codeToText[customer.city]
            }}{{ codeToText[customer.county] }}{{ customer.address_detail }}
          </dd>
        </dl>
        <dl style="min-width: 60px">
          <dt>行业</dt>
          <dd>{{ customer.industry }}</dd>
        </dl>
        <dl style="min-width: 60px">
          <dt>负责人</dt>
          <dd>{{ customer.user.name }}</dd>
        </dl>
      </div>
      <el-button
        class="mt-10"
        type="primary"
        size="small"
        icon="el-icon-edit"
        plain
        @click="updateCustomerFormVisible = true"
        >编辑客户信息</el-button
      >
    </div>
    <div class="panel mt-20">
      <el-tabs v-model="activeTab" @tab-click="clickedTab">
        <el-tab-pane label="设备" name="tab1"></el-tab-pane>
        <el-tab-pane label="拜访记录" name="tab2"></el-tab-pane>
        <el-tab-pane label="联系人" name="tab3"></el-tab-pane>
        <el-tab-pane label="基本信息" name="tab4"></el-tab-pane>
        <el-tab-pane label="动态" name="tab5"></el-tab-pane>
      </el-tabs>
    </div>
    <template v-if="activeTab == 'tab3'">
      <div class="panel mt-20">
        <div class="header flex-row-between">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="startCustomerContactFormer()"
            >添加联系人</el-button
          >
        </div>
        <el-table v-if="!isMobile()" :data="contacts" stripe key="contacts">
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column
            prop="mobile"
            label="电话"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="duty"
            label="职务"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="email"
            label="邮箱"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" width="140" align="right">
            <template slot-scope="scope">
              <div class="flex-row-between">
                <el-button
                  type="danger"
                  size="mini"
                  plain
                  @click="deleteContact(scope.$index)"
                  >删除</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="startCustomerContactFormer(scope.row, scope.$index)"
                  >修改</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <ul v-else class="list-style">
          <li v-for="(item, index) in contacts" class="flex-row-between">
            <div>
              <div>
                {{ item.name }}
                <span
                  v-if="item.duty && item.duty.length > 0"
                  class="text-info-12"
                  >({{ item.duty }})</span
                >
              </div>
              <div
                style="margin-top: 5px"
                v-if="item.mobile && item.mobile.length > 0"
              >
                <a :href="'tel:' + item.mobile">{{ item.mobile }}</a>
              </div>
              <div v-if="item.email && item.email.length > 0">
                <a :href="'mailto:' + item.email">{{ item.email }}</a>
              </div>
            </div>
            <div style="width: 122px">
              <el-button
                type="danger"
                size="mini"
                plain
                @click="deleteContact(index)"
                >删除</el-button
              >
              <el-button
                type="primary"
                size="mini"
                plain
                @click="startCustomerContactFormer(item, index)"
                >修改</el-button
              >
            </div>
          </li>
        </ul>
      </div>
    </template>
    <template v-else-if="activeTab == 'tab1'">
      <customer-device-tab :customerID="customerID"></customer-device-tab>
      <!-- <div class="panel mt-20">
        <div class="header flex-row-between">
          <h2>共{{ devices.length }}个设备</h2>
          <div style="display: flex">
            <file-button
              class="mobile-hide"
              obj="customer_device"
              :filter="{ customer_id: customerID }"
              :importButton="false"
              @importCallback="requestCustomerDevies"
            ></file-button>
            <el-button
              class="ml-10"
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="startCustomerDeviceFormer()"
              >新设备</el-button
            >
          </div>
        </div>
        <el-table
          v-if="!isMobile()"
          :data="devices"
          stripe
          style="width: 100%"
          key="devices"
        >
          <el-table-column label="序列号/设备号/机型" min-width="100">
            <template slot-scope="scope">
              <div>序列号：{{ scope.row.serial_number }}</div>
              <div>设备号：{{ scope.row.equipment_number }}</div>
              <div class="text-info-12">机型：{{ scope.row.machine_type }}</div>
            </template>
          </el-table-column>
          <el-table-column label="机型分类" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.item_category.name }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="purchase_time"
            label="发货日期"
            width="125"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ formatTime(scope.row.purchase_time) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="working_condition"
            label="工况"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="running_time"
            label="运行时长"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="product_name"
            label="公司产品"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="product_application"
            label="应用"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" width="100" align="right">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                plain
                @click="startCustomerDeviceFormer(scope.row, scope.$index)"
                >编辑信息</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <ul v-else class="list-style">
          <li
            v-for="(item, index) in devices"
            class="flex-row-between"
            style="align-items:start"
          >
            <div>
              <div>{{ item.serial_number }}</div>
              <div class="font-12">
                {{ item.item_category.name }}
                <span v-if="item.machine_type.length > 0"
                  >- {{ item.machine_type }}</span
                >
              </div>
              <div
                class="text-info-12"
                v-if="
                  item.working_condition.length > 0 || item.running_time > 0
                "
              >
                工况：{{ item.working_condition }}
                <span style="margin-left:16px"
                  >运行时长：{{ item.running_time }}</span
                >
              </div>
              <div class="text-info-12">
                发货日期：{{ formatTime(item.purchase_time) }}
              </div>
            </div>
            <div style="width: 45px">
              <el-button
                type="primary"
                size="mini"
                plain
                @click="startCustomerDeviceFormer(item, index)"
                >编辑</el-button
              >
            </div>
          </li>
        </ul>
      </div>-->
    </template>
    <template v-else-if="activeTab == 'tab4'">
      <div class="panel mt-20" v-if="customer">
        <div class="header">
          <h2>基本信息</h2>
        </div>
        <ul class="base-info">
          <li>
            <span class="title">中间商：</span>
            <span>{{ customer.dealer.name }}</span>
          </li>
          <li>
            <span class="title">销售区域：</span>
            <span>{{ AreaTextMap[customer.area_id] }}</span>
          </li>
          <li>
            <span class="title">地区：</span>
            <span>
              {{ codeToText[customer.province] }}{{ codeToText[customer.city]
              }}{{ codeToText[customer.county] }}{{ customer.address_detail }}
            </span>
          </li>
          <li>
            <span class="title">地址：</span>
            <span>{{ customer.address_detail }}</span>
          </li>
          <li>
            <span class="title">行业：</span>
            <span>{{ customer.industry }}</span>
          </li>
          <li>
            <span class="title">规模：</span>
            <span>{{ customer.scale }}</span>
          </li>
          <li>
            <span class="title">来源：</span>
            <span>{{ customer.source }}</span>
          </li>
          <li>
            <span class="title">创建日期：</span>
            <span>
              {{ $time(new Date(customer.created_at)).format('YYYY年M月D日') }}
            </span>
          </li>
        </ul>
      </div>
      <div class="panel mt-20">
        <div class="header flex-row-between">
          <h2>发票信息</h2>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="startCustomerInvoiceFormer()"
            >增加发票</el-button
          >
        </div>
        <el-table
          v-if="!isMobile()"
          :data="invoices"
          stripe
          style="width: 100%"
          header-row-class-name="q-products-header"
          key="invoices"
        >
          <el-table-column prop="title" label="企业名称"></el-table-column>
          <el-table-column
            prop="tax_number"
            label="纳税识别号"
            align="center"
          ></el-table-column>
          <el-table-column prop="bank_name" label="开户行/账号" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.bank_name }}</div>
              <div>{{ scope.row.bank_account }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="发票邮寄地址"
          ></el-table-column>
          <el-table-column align="right" label="操作" width="80">
            <template slot-scope="scope">
              <div class="flex-row-between">
                <!-- <el-button type="danger" size="mini" plain>删除</el-button> -->
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="startCustomerInvoiceFormer(scope.row, scope.$index)"
                  >修改</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <ul v-else class="list-style">
          <li v-for="(item, index) in invoices" class="flex-row-between">
            <div>
              <div>{{ item.title }}</div>
              <div class="font-12">{{ item.tax_number }}</div>
              <div class="font-12">
                {{ item.bank_name }} {{ item.bank_account }}
              </div>
              <div class="font-12">{{ item.address }}</div>
            </div>
            <el-button
              type="primary"
              size="mini"
              plain
              @click="startCustomerInvoiceFormer(item, index)"
              >修改</el-button
            >
          </li>
        </ul>
      </div>
    </template>
    <div v-else-if="activeTab == 'tab5'" class="panel mt-20">
      <div class="flex-row-between">
        <el-radio-group
          size="mini"
          v-model="logRequest.sort"
          @change="requestCustomerLogList"
          style="width: 200px"
        >
          <el-radio-button :label="0">正序</el-radio-button>
          <el-radio-button :label="1">倒序</el-radio-button>
        </el-radio-group>
        <el-select
          size="mini"
          v-model="logRequest.type"
          placeholder="动态类型"
          style="width: 160px"
          @change="requestCustomerLogList"
        >
          <el-option
            v-for="item in logTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="mt-20">
        <el-timeline style="font-size: 12px">
          <el-timeline-item
            v-for="log in logs"
            :key="log.id"
            :timestamp="formatTime(log.created_at, 'YYYY年M月D日 HH:mm')"
          >
            <div>
              <h4 class="flex-row-between">
                <span class="flex:1">
                  {{ log.title }}
                  <template v-for="link in log.links">
                    <el-tag
                      type="info"
                      class="log-tag"
                      v-if="link.url.length == 0"
                      size="mini"
                    >
                      <span class="el-icon-money"></span>
                      ￥{{ link.text }}
                    </el-tag>
                    <router-link class="log-tag" v-else :to="link.url">
                      <el-tag size="mini">{{ link.text }}</el-tag>
                    </router-link>
                  </template>
                  <!-- <el-tag size="mini">BJ-20191002</el-tag>
                    <el-tag type="info" size="mini">
                      <span class="el-icon-money"></span>￥180.00</el-tag
                  >-->
                </span>
                <span class="info" style="width: 60px; text-align: right">
                  <span class="text-primary">{{ log.user.name }}</span>
                </span>
              </h4>
              <div>{{ log.content }}</div>
              <div
                v-if="
                  log.type == 12 ||
                  log.type == 11 ||
                  log.type == 14 ||
                  log.type == 6
                "
              >
                <p v-for="(v, k) in log.params">{{ logParams(k, v) }}</p>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div v-if="logTotal > logRequest.size">
        <el-pagination
          small
          :page-size="logRequest.size"
          :current-page.sync="logRequest.page"
          layout="total, prev, pager, next"
          :total="logTotal"
        ></el-pagination>
      </div>
    </div>
    <followup-tab
      :show="activeTab == 'tab2'"
      :customerID="customerID"
      ref="followupTab"
      @newfollow="startCreateFollowup"
    ></followup-tab>

    <customer-former
      :model="customerForm"
      :show.sync="updateCustomerFormVisible"
      @updatedCustomer="updatedCustomer"
    ></customer-former>
    <followup-former
      :model="followUpForm"
      :show.sync="createFollowupFormVisible"
      @created="createdFollowup"
    ></followup-former>
    <customer-device-former
      :model="customerDeviceForm"
      :showAddress="true"
      :show.sync="createCustomerDeviceFormVisible"
      @created="createdCustomerDevcice"
      @updated="updatedCustomerDevcice"
    ></customer-device-former>
    <customer-invoice-former
      :model="customerInvoiceForm"
      :show.sync="createCustomerInvoiceFormVisible"
      @created="createdCustomerInvoice"
      @updated="updatedCustomerInvoice"
    ></customer-invoice-former>
    <customer-contact-former
      :model="customerContactForm"
      :show.sync="createCustomerContactFormVisible"
      @created="createdCustomerContact"
      @updated="updatedCustomerContact"
    ></customer-contact-former>
    <customer-collection-former
      :model="customerCollectionForm"
      :customerID="customerID"
      :show.sync="customerCollectionFormVisible"
      @created="createdCustomerCollection"
    ></customer-collection-former>
    <customer-transfer
      :model="customerTransferForm"
      :show.sync="customerTransferVisible"
      @updated="updateCustomerUser"
    ></customer-transfer>
  </div>
</template>

<script>
import { getStore } from '@/config/storage'
import CustomerFormer from '@/components/customer'
import FollowupFormer from '@/components/followup'
import CustomerDeviceFormer from '@/components/customer_device'
import CustomerInvoiceFormer from '@/components/customer_invoice'
import CustomerContactFormer from '@/components/customer_contact'
import CustomerCollectionFormer from '@/components/customer_collection'
import CustomerTransfer from '@/components/customer_transfer'
import CustomerDeviceTab from '@/views/customer_device/index'

import {
  CutomerLogTypes,
  CustomerFollowupTypes,
  QuotationStatusMap,
  CustomerOrderStatusMap,
  CustomerLogMap,
  AreaTextMap,
  CustomerDevice,
} from '@/config/global'

import { formatTime, isMobile } from '@/util/index'
import cloneDeep from 'lodash/cloneDeep'

import CollectionTab from '@/views/customer/collection'
import FollowupTab from '@/views/admin_customer/followup'
import ExpendTab from '@/views/customer/expend'
import auth from '@/util/auth'
import { CustomerStatusMap, CustomerCategroyMap } from '@/config/global'

import {
  customerDetail,
  creatCustomerContact,
  customerContactList,
  customerLogList,
  customerDeviceList,
  customerInvoiceList,
  quotationList,
  updateQuotaionStatus,
  deleteQuotation,
  customerOrderDetail,
  customerOrderList,
  customerCollectionList,
  customerFollowupList,
  deleteCustomerContact,
} from '../../service/getData'
import { CodeToText } from '@/util/area_tool'
import { clone } from '@/util'
import store from '@/store/store'

export default {
  components: {
    CustomerFormer,
    FollowupFormer,
    CustomerDeviceFormer,
    CustomerInvoiceFormer,
    CustomerContactFormer,
    CollectionTab,
    CustomerCollectionFormer,
    CustomerTransfer,
    FollowupTab,
    ExpendTab,
    CustomerDeviceTab,
  },
  data() {
    return {
      codeToText: CodeToText,
      AreaTextMap,
      CustomerStatusMap,
      activeTab: null,
      customerID: parseInt(this.$route.params.id),
      customer: {
        user: {},
      },
      isMobile,
      CustomerLogMap,
      CustomerCategroyMap,
      userInfo: store.getters.userInfo,
      customerForm: {},
      updateCustomerFormVisible: false,
      createFollowupFormVisible: false,
      createCustomerDeviceFormVisible: false,
      createCustomerInvoiceFormVisible: false,
      createCustomerContactFormVisible: false,
      customerCollectionFormVisible: false,
      customerTransferVisible: false,
      logs: [],
      auth,
      customerForm: {
        name: null,
        contact_name: null,
        contact_mobile: null,
        address: null,
      },
      customerContactForm: {
        name: '',
        duty: '',
        mobile: '',
        email: '',
      },
      customerTransferForm: {},
      quotations: [],
      orders: [],
      device: [],
      contacts: [],
      devices: [],
      invoices: [],
      followups: [],
      origin: null,
      customerRate: 4.3,
      addCustomerVisible: false,
      contact: '李先生',
      dateRange: null,
      followUpForm: {
        customer_id: parseInt(this.$route.params.id),
        type: 1,
        date: null,
        next_date: null,
        amount: '',
        target_id: 0,
        quotation_id: 0,
        content: '',
        customer_contact_id: '',
      },
      logRequest: {
        type: 0,
        sort: 0,
        page: 1,
        size: 10,
      },
      logTotal: 0,
      logTypes: CutomerLogTypes,
      collections: [],
      customerDeviceForm: {},
      customerInvoiceForm: {},
      customerCollectionForm: {},
      editDeviceIndex: -1,
      editInvoiceIndex: -1,
      editContactIndex: -1,
      formatTime: formatTime,
      followupTypes: CustomerFollowupTypes,
      quotationStatusMap: QuotationStatusMap,
      orderStatusMap: CustomerOrderStatusMap,
    }
  },
  watch: {
    'logRequest.page': function () {
      this.requestCustomerLogList()
    },
    activeTab: 'handleTabClick',
  },
  created() {
    this.activeTab = 'tab' + (this.$route.query.tab || 1)
    this.requestCustomer()
    this.handleTabClick()
  },
  methods: {
    async requestCustomer() {
      let res = await customerDetail(this.customerID)
      this.customer = res.data
      this.customerForm = clone(res.data)
    },
    async requestCustomerContactList() {
      let res = await customerContactList({
        customer_id: this.customerID,
      })
      this.contacts = res.data.list
    },
    async requestCustomerLogList() {
      let data = {
        page: this.logRequest.page - 1,
        size: this.logRequest.size,
        sort: this.logRequest.sort,
        type: this.logRequest.type,
        customer_id: this.customerID,
      }
      let res = await customerLogList(data)
      this.logTotal = res.data.total
      this.logs = res.data.list.map((log) => {
        log.title = CustomerLogMap[log.type]
        var links = []
        if (log.links.length > 0) {
          let array = log.links.split(';')
          links = array.map((item) => {
            return this.logLink(item)
          })
        }
        log.links = links
        return log
      })
    },
    async requestCustomerDevies() {
      let res = await customerDeviceList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })
      this.devices = res.data.list
    },
    async requestCustomerInvoices() {
      let res = await customerInvoiceList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })
      this.invoices = res.data.list
    },
    async requestCustomerCollections() {
      let res = await customerCollectionList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })
      this.collections = res.data.list
    },
    async requestCustomerQuotations() {
      let res = await quotationList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })
      this.quotations = res.data.list
    },
    async requestCustomerOrders() {
      let res = await customerOrderList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })
      if (res.code == 0) {
        this.orders = res.data.list
      }
    },
    submitOrder(index) {
      let that = this
      this.$confirm('是否确定提交转化订单申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        updateQuotaionStatus({ id: that.quotation.id }).then((res) => {
          if (res.code == 0) {
            that.quotations[index].status = res.data.status
          }
        })
      })
    },
    canModify(status) {
      return status == 1 || status == 3
    },
    logParams(k, v) {
      let v1,
        v2 = ''
      if (v.length > 0) {
        v1 = v[0]
      }
      if (v.length > 1) {
        v2 = v[1]
      }
      if (k == '省' || k == '市' || k == '区/县') {
        v1 = this.codeToText[v1]
        v2 = this.codeToText[v2]
      } else if (k.indexOf('时间') != -1) {
        v1 = formatTime(v1)
        v2 = formatTime(v2)
      }
      return k + '：' + v1 + ' -> ' + v2
    },
    startCreateFollowup() {
      this.followUpForm = {
        customer_id: this.customerID,
        type: 1,
        date: new Date(),
        next_date: null,
        amount: '',
        quotation_id: null,
        content: '',
        customer_contact_id: null,
      }
      this.createFollowupFormVisible = true
    },
    startCustomerDeviceFormer(device, index) {
      if (device) {
        this.customerDeviceForm = clone(device)
        this.editDeviceIndex = index
      } else {
        this.customerDeviceForm = {
          customer_id: this.customerID,
          working_condition: '',
          running_time: null,
          purchase_time: null,
          name_plate: null,
          serial_number: null,
          machine_type: null,
          item_category_id: null,
          equipment_number: null,
          product_name: null,
          product_application: null,
        }
      }
      this.createCustomerDeviceFormVisible = true
    },
    startCustomerInvoiceFormer(invoice, index) {
      if (invoice) {
        this.customerInvoiceForm = clone(invoice)
        this.editInvoiceIndex = index
      } else {
        this.customerInvoiceForm = {
          customer_id: this.customerID,
          title: '',
          bank_name: '',
          bank_account: '',
          tax_number: '',
          address: '',
        }
      }

      this.createCustomerInvoiceFormVisible = true
    },
    startCustomerContactFormer(contact, index) {
      if (contact) {
        this.customerContactForm = clone(contact)
        this.editContactIndex = index
      } else {
        this.customerContactForm = {
          customer_id: this.customerID,
          name: '',
          duty: '',
          mobile: '',
          email: '',
        }
      }
      this.createCustomerContactFormVisible = true
    },
    startCollectionFormer() {
      this.customerCollectionForm = {
        customer_id: this.customerID,
        amount: '',
        date: null,
      }

      this.customerCollectionFormVisible = true
    },
    startTransfer() {
      let form = clone(this.customer)
      form.user_id = null
      this.customerTransferForm = form
      this.customerTransferVisible = true
    },
    updatedCustomer(customer) {
      this.customer = customer
      this.customerForm = clone(customer)
      this.requestCustomerLogList()
    },
    createdFollowup(follow) {
      this.requestCustomerLogList()
      this.requestCustomerContactList()
      this.$refs.followupTab.refresh()
    },
    createdCustomerDevcice(customerDevice) {
      this.devices.unshift(customerDevice)
      this.requestCustomerLogList()
    },
    updatedCustomerDevcice(customerDevice) {
      this.devices.splice(this.editDeviceIndex, 1, customerDevice)
      this.requestCustomerLogList()
    },
    createdCustomerInvoice(invoice) {
      this.invoices.unshift(invoice)
      this.requestCustomerLogList()
    },
    updatedCustomerInvoice(invoice) {
      this.invoices.splice(this.editInvoiceIndex, 1, invoice)
      this.requestCustomerLogList()
    },
    createdCustomerContact(contact) {
      this.contacts.unshift(contact)
    },
    updatedCustomerContact(contact) {
      this.contacts.splice(this.editContactIndex, 1, contact)
      this.requestCustomerLogList()
    },
    createdCustomerCollection() {
      this.$refs.collectionTab.refresh()
    },
    updateCustomerUser(customer) {
      if (customer.user_id != this.userInfo.id) {
        this.$router.push('/dashboard/customers')
        return
      }
      this.customer = customer
      this.requestCustomerLogList()
    },
    handleTabClick() {
      if (this.activeTab == 'tab1' && this.devices.length == 0) {
        this.requestCustomerDevies()
      } else if (this.activeTab == 'tab4' && this.invoices.length == 0) {
        this.requestCustomerInvoices()
      } else if (this.activeTab == 'tab5' && this.collections.length == 0) {
        this.requestCustomerLogList()
      } else if (this.activeTab == 'tab3' && this.contacts.length == 0) {
        this.requestCustomerContactList()
      }
    },
    logLink(lnk) {
      let links = lnk.split('|')
      let text = links[0]
      let linkInfo = links[1]
      let infos = linkInfo.split(':')
      let url = ''
      if (infos[0] == 'quotation') {
        url = '/dashboard/quotations/' + infos[1]
      } else if (infos[0] == 'amount') {
        url = ''
      } else if (infos[0] == 'order') {
        url = '/dashboard/dealer/orders/' + infos[1]
      }
      return {
        text: text,
        url: url,
      }
    },
    submitApproval(index) {
      let q = this.quotations[index]
      let that = this
      this.$confirm('是否确定提交审批?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        updateQuotaionStatus({ id: q.id }).then((res) => {
          if (res.code == 0) {
            q.status = res.data.status
          }
        })
      })
    },
    deleteQuotation(index) {
      let q = this.quotations[index]
      let that = this
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteQuotation(q.id).then((res) => {
          if (res.code == 0) {
            that.quotations.splice(index, 1)
          }
        })
      })
    },
    deleteContact(index) {
      let c = this.contacts[index]
      let that = this
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteCustomerContact(c.id).then((res) => {
          if (res.code == 0) {
            that.contacts.splice(index, 1)
          }
        })
      })
    },
    clickedTab(e) {
      const index = parseInt(e.index)
      this.$router.replace({ query: { tab: index + 1 } })
    },
  },
}
</script>

<style scoped>
.customer-info-panel {
  color: #6e6446;
  backg-color: #fcedbe;
}
.customer-info-title {
  font-size: 16px;
  margin-bottom: 10px;
  color: #3e3221;
}
.customer-detail dl {
  margin: 0;
}
.customer-detail {
  display: flex;
  justify-content: space-between;
}
.customer-detail dt {
  display: block;
  color: #adb5bd;
  line-height: 1.8;
  font-size: 12px;
}
.customer-detail dd {
  display: block;
  font-size: 14px;
  line-height: 1.3;
  margin: 0;
}

h4 {
  font-size: 14px;
  color: #3e3221;
}
.actions {
  padding-top: 10px;
  box-sizing: border-box;
}
.actions button {
  margin-right: 6px;
  margin-top: 10px;
}

.customer {
  backg-color: #fff;
  padding: 20px 12px;
}
.customer-name {
  font-size: 18px;
  color: #333;
  padding: 0;
  line-height: 20px;
}
.customer .title,
.device .title {
  display: flex;
  justify-content: space-between;
}

.info li {
  color: #666;
  font-size: 12px;
}
.device {
  margin-top: 12px;
  backg-color: #fff;
  padding: 20px 12px;
}
.info {
  font-weight: normal;
}
.filter {
  font-size: 12px;
  color: #777;
}
.filter label {
  margin: 0 4px;
}

.customer-data {
  display: flex;
  margin-top: 10px;
  border-top: 1px dotted #ddd;
  padding-top: 10px;
}
.customer-data li {
  width: 25%;
  text-align: left;
}
.customer-data li span {
  display: block;
  color: #0087cb;
}

.customer-data li span.title {
  color: #909399;
  line-height: 2;
}

.yuce li {
  color: #666;
  margin-bottom: 12px;
  padding-top: 12px;
  font-size: 12px;
  border-top: 1px dotted #ddd;
}

.yuce li:first-child {
  border-top: 0 none;
}

.text-tips {
  color: #999;
  font-size: 12px;
  margin: 0;
  margin-top: 10px;
}

.log-tag {
  margin-right: 4px;
}

.el-checkbox__label {
  font-size: 12px;
}

.overview .sub-info {
  border: 0 none;
}
.overview .sub-info-value {
  font-size: 20px;
  font-weight: 400;
}
.base-info {
  display: flex;
  flex-wrap: wrap;
}
.base-info li {
  width: 50%;
  padding-top: 10px;
}
.base-info .title {
  color: #999;
}
</style>

<style  scoped>
@media (max-width: 767px) {
  .customer-detail dl {
    margin: 0;
    display: flex;
    align-items: center;
    padding: 3px 0;
  }
  .customer-detail {
    flex-direction: column;
  }
  .customer-detail dt {
    color: #adb5bd;
    line-height: 1.8;
    font-size: 12px;
    margin-right: 10px;
  }
  .customer-detail dd {
    font-size: 12px;
    line-height: 1.3;
  }
}
</style>